import { cn } from "@repo/utils";

export default function ProjetInformatiquePJ() {
  return (
    <>
      <img
        src="/logos/sytel_grand_est.png"
        alt="logo_sytel_grand_est"
        height={200}
        width={200}
      />
      <div
        className={cn("self-center border-[1px] border-black p-2 font-bold")}
      >
        PROJET INFORMATIQUE
      </div>
      <div className={cn("self-center")}>3 étapes principales :</div>

      <div className={cn("font-bold underline")}>1 - ORGANISATIONNELLE :</div>
      <ul className={cn("pl-12")}>
        <li>
          - sensibilisation impact du logiciel à la direction et aux chefs de
          service
        </li>
        <li>- interviews chefs de services + opérationnels concernés</li>
        <li>- rebouclage avec check-list</li>
        <li>- restitution aux interviewés</li>
        <li>{`- présentation du plan d'action à la direction et aux chefs de services`}</li>
      </ul>

      <div className={cn("font-bold underline")}>
        2 - ADAPTATION DES PROGRAMMES INFORMATIQUES :
      </div>
      <ul className={cn("pl-12")}>
        <li>- identification des programmes concernés</li>
        <li>{`- stratégie d'adaptation (suivant analyse organisationnelle)`}</li>
        <li>
          - adaptation des programmes et tests unitaires (estimé entre 500 et
          600 jours / homme)
        </li>
        <li>{`- tests d'intégration dans notre Direction`}</li>
      </ul>

      <div className={cn("font-bold underline")}>
        3 - IMPLANTATION DANS LES AUTRES DIRECTIONS :
      </div>
      <ul className={cn("pl-12")}>
        <li>
          - information et formation au logiciel des responsables de service
        </li>
        <li>- assistance technique lors du déploiement</li>
        <li>- feed-back des directions</li>
      </ul>
    </>
  );
}

ProjetInformatiquePJ.title = "Projet Informatique";
